import React from 'react';
import { Box, Paper, Typography, ToggleButton, ToggleButtonGroup, Link } from '@mui/material';
import coursesData from '../courses.json';

/**
 * Program metadata header component  
 * Displays program name, track, dates, and view mode selector
 */
const ProgramMeta = ({ viewMode, onViewModeChange }) => {
  const meta = coursesData.meta;

  // Extract years from start_date and expected_end_date
  const startYear = meta.start_date.match(/\d{4}/)?.[0];
  const endYear = meta.expected_end_date.match(/\d{4}/)?.[0];
  const yearRange = startYear && endYear ? ` (${startYear}-${endYear})` : '';

  return (
    <Paper elevation={2} sx={{ p: 3, mb: 1 }}>
      <Box display="flex" flexDirection={{ xs: 'column', md: 'row' }} alignItems={{ xs: 'flex-start', md: 'center' }} gap={2}>
        {/* Program Name and Track */}
        <Box sx={{ flex: 1 }}>
          <Typography variant="h4" gutterBottom>
            {meta.program_name}
          </Typography>
          <Typography variant="h6" color="text.secondary">
            Track: <Link 
              href={meta.track_url}
              target="_blank"
              rel="noopener noreferrer"
              color="primary"
              underline="hover"
              sx={{ fontWeight: 'inherit' }}
            >
              {meta.track_specialization}
            </Link>{yearRange}
          </Typography>
        </Box>
        
        {/* View Mode Toggle Buttons */}
        <Box sx={{ 
          display: 'flex', 
          flexDirection: { xs: 'column', md: 'row' },
          alignItems: { xs: 'center', md: 'center' },
          justifyContent: { xs: 'center', md: 'flex-end' },
          gap: { xs: 1, md: 2 },
          mt: { xs: 2, md: 0 }, 
          pt: { xs: 2, md: 0 }, 
          borderTop: { xs: '1px solid rgba(0, 0, 0, 0.12)', md: 'none' } 
        }}>
          <Typography 
            variant="caption" 
            color="text.secondary" 
            sx={{ 
              fontSize: '0.75rem',
              fontWeight: 500,
              whiteSpace: 'nowrap'
            }}
          >
            View as
          </Typography>
          <ToggleButtonGroup
            value={viewMode}
            exclusive
            onChange={(event, newMode) => {
              if (newMode !== null) {
                onViewModeChange(newMode);
              }
            }}
            size="small"
            sx={{
              '& .MuiToggleButton-root': {
                px: 2,
                py: 1,
                fontSize: '0.875rem',
                textTransform: 'none',
                fontWeight: 500,
                border: '1px solid rgba(25, 118, 210, 0.3)',
                '&.Mui-selected': {
                  backgroundColor: '#0d47a1',
                  color: 'white',
                  '&:hover': {
                    backgroundColor: '#0a3f7a',
                  }
                }
              }
            }}
          >
            <ToggleButton value="selection">Selection</ToggleButton>
            <ToggleButton value="review">Compact</ToggleButton>
            <ToggleButton value="timetable">Timetable</ToggleButton>
          </ToggleButtonGroup>
        </Box>
      </Box>
    </Paper>
  );
};

export default ProgramMeta; 